export default __webpack_public_path__ + "static/media/6C3_1980-2-53.9b47cb62.png";